import {
  checkPasswordValidation,
  isValidEmail,
} from "../../utils/UniversalFunction";
import { sumPercentages } from "./acceptSupplierInvitationHelpers";

export function validateContactForm(form, { requirePassword = false } = {}) {
  const errors = {};

  if (!form.first_name?.trim()) errors.first_name = "First name is required";
  if (!form.last_name?.trim()) errors.last_name = "Last name is required";
  if (!form.email?.trim() || !isValidEmail(form.email)) {
    errors.email = "Valid email is required";
  }
  const mobileDigits = form.mobile?.replace(/\D/g, "") ?? "";
  if (!mobileDigits) {
    errors.mobile = "Mobile is required";
  } else if (mobileDigits.length !== 10) {
    errors.mobile = "Mobile must be exactly 10 digits";
  }
  if (!form.country) errors.country = "Country is required";

  if (requirePassword) {
    if (!form.password?.trim()) {
      errors.password = "Password is required";
    } else {
      const passwordCheck = checkPasswordValidation(form.password);
      if (passwordCheck !== true) errors.password = passwordCheck;
    }
    if (!form.confirm_password?.trim()) {
      errors.confirm_password = "Confirm password is required";
    } else if (form.password !== form.confirm_password) {
      errors.confirm_password = "Passwords do not match";
    }
  } else if (form.password?.trim() || form.confirm_password?.trim()) {
    if (!form.password?.trim()) {
      errors.password = "Password is required when confirm password is set";
    } else {
      const passwordCheck = checkPasswordValidation(form.password);
      if (passwordCheck !== true) errors.password = passwordCheck;
    }
    if (form.password !== form.confirm_password) {
      errors.confirm_password = "Passwords do not match";
    }
  }

  return errors;
}

function isCountFieldFilled(value) {
  if (value === "" || value === null || value === undefined) return false;
  const n = Number(value);
  return Number.isFinite(n) && n >= 0;
}

function validatePercentRows(rows, fieldKey) {
  const errors = {};
  const filled = rows.filter((r) => r.name?.trim());
  if (filled.length === 0) {
    errors[fieldKey] = "At least one row with a name is required";
    return errors;
  }
  const incomplete = filled.some(
    (r) =>
      r.percentage === "" ||
      r.percentage === null ||
      r.percentage === undefined ||
      !Number.isFinite(Number(r.percentage))
  );
  if (incomplete) {
    errors[fieldKey] = "Each row must have a percentage";
    return errors;
  }
  if (sumPercentages(filled) !== 100) {
    errors[fieldKey] = "Percentages must total 100%";
  }
  return errors;
}

export function validateAcceptForm(
  form,
  industryId,
  subIndustryId,
  { canUpdate = true } = {}
) {
  const errors = {};
  if (!canUpdate) return errors;

  Object.assign(errors, validateContactForm(form, { requirePassword: true }));
  if (!form.entity_type) errors.entity_type = "Entity type is required";
  if (!form.company_name?.trim()) {
    errors.company_name = "Company name is required";
  }
  if (!form.address1?.trim()) errors.address1 = "Address line 1 is required";
  if (!form.city?.trim()) errors.city = "City is required";
  if (!form.state?.trim()) errors.state = "State is required";
  if (!form.zip_code?.trim()) errors.zip_code = "Zip code is required";
  if (!industryId) errors.industry = "Industry is required";
  if (!subIndustryId) errors.sub_industry = "Sub-industry is required";
  if (!form.employee_size_category) {
    errors.employee_size_category = "Employee size is required";
  }

  if (
    form.entity_type === "LIMITED" ||
    form.entity_type === "PRIVATE_LIMITED"
  ) {
    if (!form.cin?.trim()) errors.cin = "CIN is required";
  } else if (form.entity_type === "PROPRIETORSHIP") {
    if (!form.gstin?.trim()) errors.gstin = "GSTIN is required";
  } else if (form.entity_type === "OTHER") {
    if (!form.pan?.trim()) errors.pan = "PAN is required";
  }

  Object.assign(
    errors,
    validatePercentRows(form.business_activities, "business_activities")
  );
  Object.assign(
    errors,
    validatePercentRows(form.products_or_services, "products_or_services")
  );

  const mp = form.manufacturing_plants || {};
  if (!isCountFieldFilled(mp.national)) {
    errors.manufacturing_plants_national = "National plant count is required";
  }
  if (!isCountFieldFilled(mp.international)) {
    errors.manufacturing_plants_international =
      "International plant count is required";
  }

  const off = form.offices || {};
  if (!isCountFieldFilled(off.national)) {
    errors.offices_national = "National office count is required";
  }
  if (!isCountFieldFilled(off.international)) {
    errors.offices_international = "International office count is required";
  }

  ["permanent_employees", "non_permanent_employees"].forEach((key) => {
    const block = form[key] || {};
    ["male", "female", "others"].forEach((gender) => {
      if (!isCountFieldFilled(block[gender])) {
        errors[`${key}_${gender}`] = "Required";
      }
    });
  });

  return errors;
}
